// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixed-toolbar[data-v-e8f7e24a] {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 4.1rem;\n    z-index: 2;\n}\n", ""]);
// Exports
module.exports = exports;
